const MINUTE_IN_MS = 60 * 1000;

function addMinutesToDate(date: Date, minutes: number) {
	return new Date(date.getTime() + minutes * MINUTE_IN_MS);
}

export default addMinutesToDate;
